module.exports = __webpack_public_path__ + "media/customizations/somersett/back-6353d828754b5ce19fbf4546839024c5.jpg";